import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { showCustomToast } from "./Misc/CustomToast";
import {
  collection,
  doc,
  getDocs,
  onSnapshot,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { useEffect } from "react";
import UploaderPreAdmission from "./Updloader/UploaderPreAdmission";
import TextFieldComponentMobile from "./TextFieldComponentMobile";
import InputComponentMobile from "./InputComponentMobile";
import DropDownComponentMobile from "./DropDownComponentMobile";
import DatePickerComponent from "./DatePickerComponent";
import DropDownClientIdentifier from "./Dropdowns/DropDownClientIdentifier";
import UploaderAraEncapsulated from "./Updloader/UploaderAraEncapsulated";
import LineLogsMobile from "./Lines/LineLogsMobile";
import StandardDrawer, { StandardDrawerFooter, StandardDrawerHeader } from "./forms/StandardDrawer";
import "./PreAdmission.css";

function PreAdmissionMobile(props) {
  const styleModalUploadPdf = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    height: "auto",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [, setIsLoadingFetchLogs] = useState(false);

  const [isModified, setIsModified] = useState(false);
  const [docData, setDocData] = useState({});
  const [docDataClient, setDocDataClient] = useState({});
  const [openUploadPreAdmission, setOpenUploadPreAdmission] = useState(false);
  const handleClosePreAdmForm = () => setOpenUploadPreAdmission(false);
  const [logs, setLogs] = useState([]);
  const [isModalLogsOpen, setIsModalLogsOpen] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const closeDetailLogsModal = () => setIsDetailsModalOpen(false);
  const closeLogsModal = () => setIsModalLogsOpen(false);

  function formatDate2(value) {
    if (value && value.toDate) {
      return value.toDate().toLocaleString("en-EN", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    }
    return value;
  }

  const showLogDetails = (selectedLog) => {
    const changes = selectedLog.changes;
    const who = selectedLog.recordedBy;
    const when = formatDateLogs(selectedLog.recordedAt);

    return (
      <div className="pre-admission-detail-content">
        <div className="pre-admission-detail-summary">
          <span>Recorded by</span>
          <strong>{who}</strong>
          <time>{when}</time>
        </div>
        <div className="pre-admission-change-list">
          {Object.entries(changes)
            .filter(([key, _]) => key !== "recordedAt")
            .map(([key, value]) => (
              <article className="pre-admission-change-card" key={key}>
                <div className="pre-admission-change-field">{key}</div>
                <div className="pre-admission-change-label">New value</div>
                <div className="pre-admission-change-value">
                  {typeof value === "string"
                    ? value
                    : JSON.stringify(value, null, 2)}
                </div>
              </article>
            ))}
        </div>
      </div>
    );
  };

  const handleShowDetailsClick = (selectedLog) => {
    const sortedLogs = logs.sort(
      (a, b) => b.recordedAt.toDate() - a.recordedAt.toDate()
    );

    const selectedIndex = sortedLogs.findIndex(
      (log) => log.id === selectedLog.id
    );

    if (selectedIndex === -1) {
      setSelectedLog({ ...selectedLog, changes: selectedLog.changes });
    } else {
      const previousLog = sortedLogs[selectedIndex + 1];

      let differences = {};
      Object.keys(selectedLog.changes).forEach((key) => {
        let currentValue = selectedLog.changes[key];
        const previousValue = previousLog
          ? previousLog.changes[key]
          : undefined;

        currentValue = formatDate2(currentValue);
        if (
          (!previousLog ||
            JSON.stringify(currentValue) !== JSON.stringify(previousValue)) &&
          currentValue !== undefined &&
          currentValue !== null &&
          currentValue !== ""
        ) {
          differences[key] = currentValue;
        }
      });

      setSelectedLog({ ...selectedLog, changes: differences });
    }

    setIsDetailsModalOpen(true);
  };

  const fetchLogs = async (clientId) => {
    setIsLoadingFetchLogs(true);
    try {
      const querySnapshot = await getDocs(
        collection(db, "logs", clientId, "modifications")
      );
      const fetchedLogs = [];
      querySnapshot.forEach((doc) => {
        fetchedLogs.push({ id: doc.id, ...doc.data() });
      });
      setLogs(fetchedLogs);
    } catch (error) {
      console.error("Error fetching logs: ", error);
    } finally {
      setIsLoadingFetchLogs(false);
    }
  };

  const openModalLogs = (clientId) => {
    fetchLogs(clientId);
    setIsModalLogsOpen(true);
  };

  const formatDateLogs = (timestamp) => {
    const date = timestamp.toDate();
    return date.toLocaleString();
  };

  useEffect(() => {
    const docRef = doc(db, "preAdmissionAssessments", props.clientId);
    const unsubscribe = onSnapshot(docRef, (doc) => {
      if (doc.exists()) {
        setDocData(doc.data());
      } else {
        console.log("No such document!");
      }
    });

    return () => unsubscribe(); // Clean up subscription on unmount
  }, [props.clientId]);

  useEffect(() => {
    const docRef = doc(db, "clients", props.clientId);
    const unsubscribe = onSnapshot(docRef, (doc) => {
      if (doc.exists()) {
        setDocDataClient(doc.data());
      } else {
        console.log("No such document!");
      }
    });

    return () => unsubscribe();
  }, [props.clientId]);

  useEffect(() => {
    // Pour les TextFieldComponent
    setNationality(docData.nationality || "");
    setMaritalStatus(docData.maritalStatus || "");
    setPrimaryAddiction(docData.primaryAddiction || "");

    // Pour les InputComponent
    setPassportStatus(docData.passportStatus || "");
    setCurrentPartner(docData.currentPartner || "");
    setSuicidalThoughtsWhen(docData.suicidalThoughtsWhen || "");
    setSuicidalThoughtsIntent(docData.suicidalThoughtsIntent || "");
    setSuicidePlan(docData.suicidePlan || "");
    setSuicideAttemptsWhen(docData.suicideAttemptsWhen || "");
    setBodyHeight(docData.bodyHeight || "");
    setAddictionOther(docData.addictionOther || "");

    // Pour les TextFieldComponentLarge
    setCurrentLivingArrangements(docData.currentLivingArrangements || "");
    setDietaryRequirements(docData.dietaryRequirements || "");
    setFundingSource(docData.fundingSource || "");
    setCurrentWithdrawalSymptoms(docData.currentWithdrawalSymptoms || "");
    setProcessAddictions(docData.processAddictions || "");
    setAddictionTreatmentHistory(docData.addictionTreatmentHistory || "");
    setTreatmentGoals(docData.treatmentGoals || "");
    setBarriersForRehab(docData.barriersForRehab || "");
    setMotivationForTreatment(docData.motivationForTreatment || "");
    setCurrentMentalHealthIssues(docData.currentMentalHealthIssues || "");
    setLastSelfHarm(docData.lastSelfHarm || "");
    setTraumaHistory(docData.traumaHistory || "");
    setCurrentProvider(docData.currentProvider || "");
    setHistoryOfSeizures(docData.historyOfSeizures || false);
    setCurrentMedications(docData.currentMedications || "");
    setCurrentPastInjury(docData.currentPastInjury || "");
    setCurrentMedicalIllness(docData.currentMedicalIllness || "");
    setAllergies(docData.allergies || "");
    setLegalProblems(docData.legalProblems || "");
    setTherapistPreference(docData.therapistPreference || "");
    setDiscoverMiraclesAsia(docData.discoverMiraclesAsia || "");
    setEatingDisorderDiagnosis(docData.eatingDisorderDiagnosis || "");
    setEatingDisorderFoodConsumption(
      docData.eatingDisorderFoodConsumption || ""
    );
    setEatingDisorderVomitingLaxatives(
      docData.eatingDisorderVomitingLaxatives || ""
    );
    setTraumaTreatment(docData.traumaTreatment || "");
    setMentalHealthTreatment(docData.mentalHealthTreatment || "");
    setSelfHarmType(docData.selfHarmType || "");
    setUnwantedConsequencesOfAddiction(
      docData.unwantedConsequencesOfAddiction || ""
    );
    setReasonForSeekingTreatment(docData.reasonForSeekingTreatment || "");
    setSubstanceAddiction(docData.substanceAddiction || "");
    setChildrenOrDependents(docData.childrenOrDependents || "");

    // Pour les Checkbox
    setMentalHealthDiagnosis(docData.mentalHealthDiagnosis || false);
    setAnxiety(docData.anxiety || false);
    setDepression(docData.depression || false);
    setPtsd(docData.ptsd || false);
    setPersonalityDisorder(docData.personalityDisorder || false);
    setSchizophrenia(docData.schizophrenia || false);
    setSchizoaffectiveDisorder(docData.schizoaffectiveDisorder || false);
    setBipolar(docData.bipolar || false);
    setBipolarWithPsychoticFeatures(
      docData.bipolarWithPsychoticFeatures || false
    );
    setPreviousPersonalityDisorder(
      docData.previousPersonalityDisorder || false
    );
    setActivePsychosis(docData.activePsychosis || false);
    setDiagnosisWithPsychoticFeatures(
      docData.diagnosisWithPsychoticFeatures || false
    );
    setRecentSelfHarm(docData.recentSelfHarm || false);
    setViolentBehavior(docData.violentBehavior || false);
    setHistoryOfSeizure(docData.historyOfSeizure || false);
    setActiveFoodRestriction(docData.activeFoodRestriction || false);
    setCurrentMobilityIssues(docData.currentMobilityIssues || false);
    setCurrentComplexMedicalIssues(
      docData.currentComplexMedicalIssues || false
    );
    setHistoryOfSuicideAttempts(docData.historyOfSuicideAttempts || false);
    setSuicidalThoughts(docData.suicidalThoughts || false);
    setHallucinations(docData.hallucinations || false);
    setDelusionalThinking(docData.delusionalThinking || false);
    setHallucinationsExplain(docData.hallucinationsExplain || "");
    setDelusionalThinkingExplain(docData.delusionalThinkingExplain || "");
    setNoneApply(docData.noneApply || false);
    setAdhd(docData.adhd || "");
    setPassportCopy(docData.passportCopy || "");
    setFlightDetails(docData.flightDetails || "");
    setVipTransfer(docData.vipTransfer || "");
    setPaymentDetails(docData.paymentDetails || "");
    setNeedsNonSmokingRoom(docData.needsNonSmokingRoom || "");
    setSecondaryAddiction(docData.secondaryAddiction || "");
    setSecondaryAddictionOther(docData.secondaryAddictionOther || "");
    setEta(docDataClient.eta || "");
    setFlightDetailsContent(docData.flightDetailsContent);
    setSuicidalIdeation(docData.suicidalIdeation || false);
    setSuicideAttempt(docData.suicideAttempt || false);
    setHistoryPhysicalViolent(docData.historyPhysicalViolent || "");
    setAssessmentStatus(docData.assessmentStatus || "");
    setAssessmentReason(docData.assessmentReason || "");
    setPreviousClientIdentifier(docData.previousClientIdentifier || "");
    setSpecificDisorder(docData.specificDisorder || "");
    setBipolar12(docData.bipolar12 || false);
    setClientUnderstand(docData.clientUnderstand || "");
    setDurationOfStay(docDataClient.durationOfStay || "");
  }, [docData, docDataClient]);

  // Pour les DropDownComponent

  const [durationOfStay, setDurationOfStay] = useState(
    props.durationOfStay || ""
  );
  const requiresDurationOfStay =
    props.rehabId !== "miracles_asia_philippines" &&
    props.rehabCountry !== "Philippines" &&
    docDataClient?.rehabId !== "miracles_asia_philippines" &&
    docDataClient?.rehabCountry !== "Philippines";

  const handleDurationOfStayChange = (value) => {
    setIsModified(true);
    setDurationOfStay(value);
  };

  const [specificDisorder, setSpecificDisorder] = useState("");

  const handleSpecificDisorderChange = (event) => {
    setSpecificDisorder(event.target.value);
  };
  const [eta, setEta] = useState(docDataClient.eta || "");

  const [nationality, setNationality] = useState(docData.nationality || "");
  const [adhd, setAdhd] = useState(docData.adhd || "");
  const [noneApply, setNoneApply] = useState(docData.noneApply || "");
  const [addictionOther, setAddictionOther] = useState(
    docData.addictionOther || ""
  );
  const [maritalStatus, setMaritalStatus] = useState(
    docData.maritalStatus || ""
  );

  const [passportCopy, setPassportCopy] = useState(docData.passportCopy || "");

  const [primaryAddiction, setPrimaryAddiction] = useState(
    docData.primaryAddiction || ""
  );
  const [needsNonSmokingRoom, setNeedsNonSmokingRoom] = useState(
    docData.needsNonSmokingRoom || ""
  );

  // Pour les InputComponent
  const [passportStatus, setPassportStatus] = useState(
    docData.passportStatus || ""
  );
  const [currentPartner, setCurrentPartner] = useState(
    docData.currentPartner || ""
  );
  const [suicidalThoughtsWhen, setSuicidalThoughtsWhen] = useState(
    docData.suicidalThoughtsWhen || ""
  );
  const [suicidalThoughtsIntent, setSuicidalThoughtsIntent] = useState(
    docData.suicidalThoughtsIntent || ""
  );
  const [suicidePlan, setSuicidePlan] = useState(docData.suicidePlan || "");
  const [suicideAttemptsWhen, setSuicideAttemptsWhen] = useState(
    docData.suicideAttemptsWhen || ""
  );
  const [bodyHeight, setBodyHeight] = useState(docData.bodyHeight || "");

  // Pour les TextFieldComponentLarge
  const [currentLivingArrangements, setCurrentLivingArrangements] = useState(
    docData.currentLivingArrangements || ""
  );
  const [dietaryRequirements, setDietaryRequirements] = useState(
    docData.dietaryRequirements || ""
  );
  const [fundingSource, setFundingSource] = useState(
    docData.fundingSource || ""
  );
  const [currentWithdrawalSymptoms, setCurrentWithdrawalSymptoms] = useState(
    docData.currentWithdrawalSymptoms || ""
  );
  const [processAddictions, setProcessAddictions] = useState(
    docData.processAddictions || ""
  );
  const [addictionTreatmentHistory, setAddictionTreatmentHistory] = useState(
    docData.addictionTreatmentHistory || ""
  );
  const [treatmentGoals, setTreatmentGoals] = useState(
    docData.treatmentGoals || ""
  );
  const [barriersForRehab, setBarriersForRehab] = useState(
    docData.barriersForRehab || ""
  );
  const [motivationForTreatment, setMotivationForTreatment] = useState(
    docData.motivationForTreatment || ""
  );
  const [currentMentalHealthIssues, setCurrentMentalHealthIssues] = useState(
    docData.currentMentalHealthIssues || ""
  );
  const [lastSelfHarm, setLastSelfHarm] = useState(docData.lastSelfHarm || "");
  const [traumaHistory, setTraumaHistory] = useState(
    docData.traumaHistory || ""
  );
  const [historyPhysicalViolent, setHistoryPhysicalViolent] = useState(
    docData.historyPhysicalViolent || ""
  );
  const [currentProvider, setCurrentProvider] = useState(
    docData.currentProvider || ""
  );
  const [historyOfSeizures, setHistoryOfSeizures] = useState(
    docData.historyOfSeizures || ""
  );
  const [currentMedications, setCurrentMedications] = useState(
    docData.currentMedications || ""
  );
  const [currentPastInjury, setCurrentPastInjury] = useState(
    docData.currentPastInjury || ""
  );
  const [currentMedicalIllness, setCurrentMedicalIllness] = useState(
    docData.currentMedicalIllness || ""
  );
  const [allergies, setAllergies] = useState(docData.allergies || "");
  const [legalProblems, setLegalProblems] = useState(
    docData.legalProblems || ""
  );
  const [therapistPreference, setTherapistPreference] = useState(
    docData.therapistPreference || ""
  );
  const [discoverMiraclesAsia, setDiscoverMiraclesAsia] = useState(
    docData.discoverMiraclesAsia || ""
  );
  const [eatingDisorderDiagnosis, setEatingDisorderDiagnosis] = useState(
    docData.eatingDisorderDiagnosis || ""
  );
  const [eatingDisorderFoodConsumption, setEatingDisorderFoodConsumption] =
    useState(docData.eatingDisorderFoodConsumption || "");
  const [eatingDisorderVomitingLaxatives, setEatingDisorderVomitingLaxatives] =
    useState(docData.eatingDisorderVomitingLaxatives || "");
  const [traumaTreatment, setTraumaTreatment] = useState(
    docData.traumaTreatment || ""
  );
  const [mentalHealthTreatment, setMentalHealthTreatment] = useState(
    docData.mentalHealthTreatment || ""
  );
  const [selfHarmType, setSelfHarmType] = useState(docData.selfHarmType || "");
  const [unwantedConsequencesOfAddiction, setUnwantedConsequencesOfAddiction] =
    useState(docData.unwantedConsequencesOfAddiction || "");
  const [reasonForSeekingTreatment, setReasonForSeekingTreatment] = useState(
    docData.reasonForSeekingTreatment || ""
  );
  const [substanceAddiction, setSubstanceAddiction] = useState(
    docData.substanceAddiction || ""
  );
  const [childrenOrDependents, setChildrenOrDependents] = useState(
    docData.childrenOrDependents || ""
  );

  // Pour les Checkbox
  const [mentalHealthDiagnosis, setMentalHealthDiagnosis] = useState(
    docData.mentalHealthDiagnosis || false
  );
  const [anxiety, setAnxiety] = useState(docData.anxiety || false);
  const [depression, setDepression] = useState(docData.depression || false);
  const [ptsd, setPtsd] = useState(docData.ptsd || false);
  const [personalityDisorder, setPersonalityDisorder] = useState(
    docData.personalityDisorder || false
  );
  const [schizophrenia, setSchizophrenia] = useState(
    docData.schizophrenia || false
  );
  const [schizoaffectiveDisorder, setSchizoaffectiveDisorder] = useState(
    docData.schizoaffectiveDisorder || false
  );
  const [bipolar, setBipolar] = useState(docData.bipolar || false);
  const [bipolarWithPsychoticFeatures, setBipolarWithPsychoticFeatures] =
    useState(docData.bipolarWithPsychoticFeatures || false);
  const [previousPersonalityDisorder, setPreviousPersonalityDisorder] =
    useState(docData.previousPersonalityDisorder || false);

  const [bipolar12, setBipolar12] = useState(docData.bipolar12 || false);
  const [activePsychosis, setActivePsychosis] = useState(
    docData.activePsychosis || false
  );
  const [diagnosisWithPsychoticFeatures, setDiagnosisWithPsychoticFeatures] =
    useState(docData.diagnosisWithPsychoticFeatures || false);
  const [recentSelfHarm, setRecentSelfHarm] = useState(
    docData.recentSelfHarm || false
  );
  const [violentBehavior, setViolentBehavior] = useState(
    docData.violentBehavior || false
  );
  const [historyOfSeizure, setHistoryOfSeizure] = useState(
    docData.historyOfSeizure || false
  );
  const [activeFoodRestriction, setActiveFoodRestriction] = useState(
    docData.activeFoodRestriction || false
  );
  const [currentMobilityIssues, setCurrentMobilityIssues] = useState(
    docData.currentMobilityIssues || false
  );
  const [currentComplexMedicalIssues, setCurrentComplexMedicalIssues] =
    useState(docData.currentComplexMedicalIssues || false);
  const [historyOfSuicideAttempts, setHistoryOfSuicideAttempts] = useState(
    docData.historyOfSuicideAttempts || false
  );
  const [suicidalThoughts, setSuicidalThoughts] = useState(
    docData.suicidalThoughts || false
  );

  const [hallucinations, setHallucinations] = useState(
    docData.hallucinations || false
  );

  const [hallucinationsExplain, setHallucinationsExplain] = useState(
    docData.hallucinationsExplain || ""
  );

  const [delusionalThinking, setDelusionalThinking] = useState(
    docData.delusionalThinking || false
  );

  const [delusionalThinkingExplain, setDelusionalThinkingExplain] = useState(
    docData.delusionalThinkingExplain || ""
  );

  const [flightDetails, setFlightDetails] = useState(
    docData.flightDetails || ""
  );

  const [flightDetailsContent, setFlightDetailsContent] = useState(
    docData.flightDetailsContent || ""
  );
  const [vipTransfer, setVipTransfer] = useState(docData.vipTransfer || "");
  const [paymentDetails, setPaymentDetails] = useState(
    docData.paymentDetails || ""
  );

  const [secondaryAddictionOther, setSecondaryAddictionOther] = useState(
    docData.secondartAddictionOther || ""
  );

  const [secondaryAddiction, setSecondaryAddiction] = useState(
    docData.secondaryAddiction || ""
  );

  const [suicideAttempt, setSuicideAttempt] = useState(
    docData.suicideAttempt || false
  );

  const [suicidalIdeation, setSuicidalIdeation] = useState(
    docData.suicidalIdeation || false
  );

  const [assessmentStatus, setAssessmentStatus] = useState(
    docData.assessmentStatus || ""
  );

  const [assessmentReason, setAssessmentReason] = useState(
    docData.assessmentReason || ""
  );

  const [previousClientIdentifier, setPreviousClientIdentifier] = useState(
    docData.previousClientIdentifier || ""
  );

  const [clientUnderstand, setClientUnderstand] = useState(
    docData.clientUnderstand || false
  );

  // Handle functions

  const handleClientUnderstand = (event) => {
    setIsModified(true);
    setClientUnderstand(event.target.checked);
  };

  const handlEtaChange = (event) => {
    setIsModified(true);
    setEta(event);
  };

  const handlePreviousClientIdentifier = (value) => {
    setIsModified(true);
    setPreviousClientIdentifier(value);
  };

  const handleAssessmentReason = (value) => {
    setIsModified(true);
    setAssessmentReason(value);
  };

  const handleAssessmentStatus = (event) => {
    setIsModified(true);
    setAssessmentStatus(event);
  };

  const handleFlightDetailsChange = (value) => {
    setIsModified(true);
    setFlightDetails(value);
  };
  const handleHistoryPhysicalViolence = (e) => {
    setIsModified(true);
    setHistoryPhysicalViolent(e);
  };
  const handleVipTransferChange = (value) => {
    setIsModified(true);
    setVipTransfer(value);
  };
  const handlePaymentDetailsChange = (value) => {
    setIsModified(true);
    setPaymentDetails(value);
  };

  const handleFlightDetailsContent = (event) => {
    setIsModified(true);
    setFlightDetailsContent(event);
  };

  // Pour les DropDownComponent

  const handleAdhd = (event) => {
    setIsModified(true);
    setAdhd(event.target.checked);
  };

  const handleNoneApplyChange = (event) => {
    setIsModified(true);
    setNoneApply(event.target.checked);
  };

  const handleHallucinationsChange = (event) => {
    setIsModified(true);
    setHallucinations(event.target.value);
  };

  const handleHallucinationsExplainChange = (event) => {
    setIsModified(true);
    setHallucinationsExplain(event);
  };

  const handleDelusionalThinking = (event) => {
    setIsModified(true);
    setDelusionalThinking(event.target.value);
  };

  const handleDelusionalThinkingExplain = (event) => {
    setIsModified(true);
    setDelusionalThinkingExplain(event);
  };

  const handleNationalityChange = (event) => {
    setIsModified(true);
    setNationality(event);
  };

  const handleMaritalStatusChange = (event) => {
    setIsModified(true);
    setMaritalStatus(event);
  };

  const handlePassportCopy = (event) => {
    setIsModified(true);
    setPassportCopy(event);
  };

  const handlePrimaryAddictionChange = (event) => {
    setIsModified(true);
    setPrimaryAddiction(event);
  };

  // Pour les InputComponent
  const handleAddictionOther = (event) => {
    setIsModified(true);
    setAddictionOther(event);
  };

  const handlePassportStatusChange = (event) => {
    setIsModified(true);
    setPassportStatus(event);
  };

  const handleCurrentPartnerChange = (event) => {
    setIsModified(true);
    setCurrentPartner(event);
  };

  const handleSuicidalThoughtsWhenChange = (event) => {
    setIsModified(true);
    setSuicidalThoughtsWhen(event);
  };

  const handleSuicidalThoughtsIntentChange = (event) => {
    setIsModified(true);
    setSuicidalThoughtsIntent(event);
  };

  const handleSuicidePlanChange = (event) => {
    setIsModified(true);
    setSuicidePlan(event);
  };

  const handleSuicideAttemptsWhenChange = (event) => {
    setIsModified(true);
    setSuicideAttemptsWhen(event);
  };

  const handleBodyHeightChange = (event) => {
    setIsModified(true);
    setBodyHeight(event);
  };

  // Pour les TextFieldComponentLarge

  const handleCurrentLivingArrangementsChange = (event) => {
    setIsModified(true);
    setCurrentLivingArrangements(event);
  };
  const handleDietaryRequirementsChange = (event) => {
    setIsModified(true);
    setDietaryRequirements(event);
  };
  const handleFundingSourceChange = (event) => {
    setIsModified(true);
    setFundingSource(event);
  };
  const handleCurrentWithdrawalSymptomsChange = (event) => {
    setIsModified(true);
    setCurrentWithdrawalSymptoms(event);
  };
  const handleProcessAddictionsChange = (event) => {
    setIsModified(true);
    setProcessAddictions(event);
  };
  const handleAddictionTreatmentHistoryChange = (event) => {
    setIsModified(true);
    setAddictionTreatmentHistory(event);
  };
  const handleTreatmentGoalsChange = (event) => {
    setIsModified(true);
    setTreatmentGoals(event);
  };
  const handleBarriersForRehabChange = (event) => {
    setIsModified(true);
    setBarriersForRehab(event);
  };
  const handleMotivationForTreatmentChange = (event) => {
    setIsModified(true);
    setMotivationForTreatment(event);
  };
  const handleCurrentMentalHealthIssuesChange = (event) => {
    setIsModified(true);
    setCurrentMentalHealthIssues(event);
  };
  const handleLastSelfHarmChange = (event) => {
    setIsModified(true);
    setLastSelfHarm(event);
  };
  const handleTraumaHistoryChange = (event) => {
    setIsModified(true);
    setTraumaHistory(event);
  };
  const handleCurrentProviderChange = (event) => {
    setIsModified(true);
    setCurrentProvider(event);
  };
  const handleHistoryOfSeizuresChange = (event) => {
    setIsModified(true);
    setHistoryOfSeizures(event);
  };
  const handleCurrentMedicationsChange = (event) => {
    setIsModified(true);
    setCurrentMedications(event);
  };
  const handleCurrentPastInjuryChange = (event) => {
    setIsModified(true);
    setCurrentPastInjury(event);
  };
  const handleCurrentMedicalIllnessChange = (event) => {
    setIsModified(true);
    setCurrentMedicalIllness(event);
  };
  const handleAllergiesChange = (event) => {
    setIsModified(true);
    setAllergies(event);
  };
  const handleLegalProblemsChange = (event) => {
    setIsModified(true);
    setLegalProblems(event);
  };
  const handleTherapistPreferenceChange = (event) => {
    setIsModified(true);
    setTherapistPreference(event);
  };

  const handleDiscoverMiraclesAsiaChange = (e) => {
    setIsModified(true);
    setDiscoverMiraclesAsia(e);
  };
  const handleEatingDisorderDiagnosisChange = (e) => {
    setIsModified(true);
    setEatingDisorderDiagnosis(e);
  };
  const handleEatingDisorderFoodConsumptionChange = (e) => {
    setIsModified(true);
    setEatingDisorderFoodConsumption(e);
  };
  const handleEatingDisorderVomitingLaxativesChange = (e) => {
    setIsModified(true);
    setEatingDisorderVomitingLaxatives(e);
  };
  const handleTraumaTreatmentChange = (e) => {
    setIsModified(true);
    setTraumaTreatment(e);
  };
  const handleMentalHealthTreatmentChange = (e) => {
    setIsModified(true);
    setMentalHealthTreatment(e);
  };
  const handleSelfHarmTypeChange = (e) => {
    setIsModified(true);
    setSelfHarmType(e);
  };
  const handleUnwantedConsequencesOfAddictionChange = (e) => {
    setIsModified(true);
    setUnwantedConsequencesOfAddiction(e);
  };
  const handleReasonForSeekingTreatmentChange = (e) => {
    setIsModified(true);
    setReasonForSeekingTreatment(e);
  };
  const handleSubstanceAddictionChange = (e) => {
    setIsModified(true);
    setSubstanceAddiction(e);
  };
  const handleChildrenOrDependentsChange = (e) => {
    setIsModified(true);
    setChildrenOrDependents(e);
  };

  // Checkbox

  const handleHistoryOfSuicideAttemptsChange = (event) => {
    setIsModified(true);
    setHistoryOfSuicideAttempts(event.target.value);
  };

  const handleSuicidalThoughtsChange = (event) => {
    setIsModified(true);
    setSuicidalThoughts(event.target.value);
  };

  const handlePreviousPersonalityDisorderChange = (event) => {
    setIsModified(true);
    setPreviousPersonalityDisorder(event.target.checked);
  };

  const handleBipolar12Change = (event) => {
    setIsModified(true);
    setBipolar12(event.target.checked);
  };

  const handleActivePsychosisChange = (event) => {
    setIsModified(true);
    setActivePsychosis(event.target.checked);
  };

  const handleDiagnosisWithPsychoticFeaturesChange = (event) => {
    setIsModified(true);
    setDiagnosisWithPsychoticFeatures(event.target.checked);
  };

  const handleRecentSelfHarmChange = (event) => {
    setIsModified(true);
    setRecentSelfHarm(event.target.checked);
  };

  const handleViolentBehaviorChange = (event) => {
    setIsModified(true);
    setViolentBehavior(event.target.checked);
  };

  const handleHistoryOfSeizureChange = (event) => {
    setIsModified(true);
    setHistoryOfSeizure(event.target.checked);
  };

  const handleActiveFoodRestrictionChange = (event) => {
    setIsModified(true);
    setActiveFoodRestriction(event.target.checked);
  };

  const handleCurrentMobilityIssuesChange = (event) => {
    setIsModified(true);
    setCurrentMobilityIssues(event.target.checked);
  };

  const handleCurrentComplexMedicalIssuesChange = (event) => {
    setIsModified(true);
    setCurrentComplexMedicalIssues(event.target.checked);
  };
  const handleSuicidalIdeationChange = (event) => {
    setIsModified(true);
    setSuicidalIdeation(event.target.checked);
  };

  const handleSuicideAttemptChange = (event) => {
    setSuicideAttempt(event.target.checked);
  };

  const handleMentalHealthDiagnosisChange = (event) => {
    setIsModified(true);
    setMentalHealthDiagnosis(event.target.value);
  };

  const handleAnxietyChange = (event) => {
    setIsModified(true);
    setAnxiety(event.target.checked);
  };

  const handleDepressionChange = (event) => {
    setIsModified(true);
    setDepression(event.target.checked);
  };

  const handlePtsdChange = (event) => {
    setIsModified(true);
    setPtsd(event.target.checked);
  };

  const handleSecondaryAddictionChange = (event) => {
    setIsModified(true);
    setSecondaryAddiction(event);
  };
  const handleSecondaryAddictionOther = (event) => {
    setIsModified(true);
    setSecondaryAddictionOther(event);
  };

  const handlePersonalityDisorderChange = (event) => {
    setIsModified(true);
    setPersonalityDisorder(event.target.checked);
  };

  const handleSchizophreniaChange = (event) => {
    setIsModified(true);
    setSchizophrenia(event.target.checked);
  };

  const handleSchizoaffectiveDisorderChange = (event) => {
    setIsModified(true);
    setSchizoaffectiveDisorder(event.target.checked);
  };

  const handleBipolarChange = (event) => {
    setIsModified(true);
    setBipolar(event.target.checked);
  };

  const handleBipolarWithPsychoticFeaturesChange = (event) => {
    setIsModified(true);
    setBipolarWithPsychoticFeatures(event.target.value);
  };

  //FUNCTIONS

  async function saveToFirestore(clientId) {
    setIsLoading(true);

    try {
      const clientRef = doc(db, "clients", clientId);
      await setDoc(doc(db, "preAdmissionAssessments", clientId), {
        nationality,
        maritalStatus,
        primaryAddiction,
        secondaryAddiction,
        needsNonSmokingRoom,
        secondaryAddictionOther,
        passportStatus,
        currentPartner,
        suicidalThoughtsWhen,
        suicidalThoughtsIntent,
        suicidePlan,
        suicideAttemptsWhen,
        bodyHeight,
        currentLivingArrangements,
        dietaryRequirements,
        fundingSource,
        currentWithdrawalSymptoms,
        processAddictions,
        addictionTreatmentHistory,
        treatmentGoals,
        barriersForRehab,
        motivationForTreatment,
        currentMentalHealthIssues,
        lastSelfHarm,
        traumaHistory,
        currentProvider,
        historyOfSeizures,
        currentMedications,
        currentPastInjury,
        currentMedicalIllness,
        allergies,
        legalProblems,
        therapistPreference,
        discoverMiraclesAsia,
        eatingDisorderDiagnosis,
        eatingDisorderFoodConsumption,
        eatingDisorderVomitingLaxatives,
        traumaTreatment,
        mentalHealthTreatment,
        selfHarmType,
        unwantedConsequencesOfAddiction,
        reasonForSeekingTreatment,
        substanceAddiction,
        childrenOrDependents,
        mentalHealthDiagnosis,
        anxiety,
        depression,
        ptsd,
        personalityDisorder,
        schizophrenia,
        schizoaffectiveDisorder,
        bipolar,
        bipolarWithPsychoticFeatures,
        previousPersonalityDisorder,
        activePsychosis,
        diagnosisWithPsychoticFeatures,
        recentSelfHarm,
        violentBehavior,
        historyOfSeizure,
        activeFoodRestriction,
        currentMobilityIssues,
        currentComplexMedicalIssues,
        historyOfSuicideAttempts,
        suicidalThoughts,
        recordedAt: serverTimestamp(),
        recordedBy: currentUser?.displayName,
        addictionOther,
        hallucinations,
        delusionalThinking,
        hallucinationsExplain,
        delusionalThinkingExplain,
        noneApply,
        adhd,
        passportCopy,
        flightDetails,
        flightDetailsContent: flightDetailsContent || "",
        vipTransfer,
        paymentDetails,
        eta,
        suicidalIdeation,
        suicideAttempt,
        historyPhysicalViolent,
        assessmentStatus,
        assessmentReason,
        previousClientIdentifier,
        specificDisorder,
        bipolar12,
      });

      await updateDoc(clientRef, {
        nationality,
        maritalStatus,
        primaryAddiction,
        secondaryAddiction,
        addictionOther,
        secondaryAddictionOther,
        eta,
        durationOfStay,
      });

      const newData = {
        nationality,
        maritalStatus,
        primaryAddiction,
        secondaryAddiction,
        passportStatus,
        currentPartner,
        suicidalThoughtsWhen,
        suicidalThoughtsIntent,
        suicidePlan,
        suicideAttemptsWhen,
        bodyHeight,
        currentLivingArrangements,
        dietaryRequirements,
        fundingSource,
        currentWithdrawalSymptoms,
        processAddictions,
        addictionTreatmentHistory,
        treatmentGoals,
        barriersForRehab,
        motivationForTreatment,
        currentMentalHealthIssues,
        lastSelfHarm,
        traumaHistory,
        currentProvider,
        historyOfSeizures,
        currentMedications,
        currentPastInjury,
        currentMedicalIllness,
        allergies,
        legalProblems,
        therapistPreference,
        discoverMiraclesAsia,
        eatingDisorderDiagnosis,
        eatingDisorderFoodConsumption,
        eatingDisorderVomitingLaxatives,
        traumaTreatment,
        mentalHealthTreatment,
        selfHarmType,
        unwantedConsequencesOfAddiction,
        reasonForSeekingTreatment,
        substanceAddiction,
        childrenOrDependents,
        mentalHealthDiagnosis,
        anxiety,
        depression,
        ptsd,
        personalityDisorder,
        schizophrenia,
        schizoaffectiveDisorder,
        bipolar,
        bipolarWithPsychoticFeatures,
        previousPersonalityDisorder,
        activePsychosis,
        diagnosisWithPsychoticFeatures,
        recentSelfHarm,
        violentBehavior,
        historyOfSeizure,
        activeFoodRestriction,
        currentMobilityIssues,
        currentComplexMedicalIssues,
        historyOfSuicideAttempts,
        suicidalThoughts,
        recordedAt: serverTimestamp(),
        recordedBy: currentUser?.displayName,
        addictionOther,
        secondaryAddictionOther,
        hallucinations,
        delusionalThinking,
        hallucinationsExplain,
        delusionalThinkingExplain,
        noneApply,
        adhd,
        passportCopy,
        flightDetails,
        vipTransfer,
        paymentDetails,
        // howLongUsingDrink,
        // mentalHealthOtherCheck,
        // mentalHealthOtherContent,
        flightDetailsContent,
        eta,
        suicidalIdeation,
        suicideAttempt,
        historyPhysicalViolent,
        assessmentStatus,
        assessmentReason,
        previousClientIdentifier,
        specificDisorder,
        bipolar12,
        durationOfStay,
        clientUnderstand,
      };

      const clientLogsRef = doc(
        collection(db, "logs", clientId, "modifications")
      );

      const logEntry = {
        clientId,
        changes: newData, // ou une sélection spécifique de newData si tout n'est pas pertinent
        recordedBy: currentUser?.displayName,
        recordedAt: serverTimestamp(),
      };
      await setDoc(clientLogsRef, logEntry);

      showCustomToast(
        "Pre admission document successfully recorded",
        "success"
      );
    } catch (error) {
      showCustomToast("Error recording Pre admission assessment", "error");
      console.error("Error adding document: ", error);
    } finally {
      setIsModified(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    props.onModificationChange(isModified);
  }, [isModified]);

  return (
    <div className="tab-container-white-mobile-bis pre-admission-tab">
      <Modal
        open={openUploadPreAdmission}
        onClose={handleClosePreAdmForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalUploadPdf}>
          <UploaderPreAdmission {...props} closemodal={handleClosePreAdmForm} />
        </Box>
      </Modal>
      <div
        className="container-main-plan-mobile-with-padding"
        style={{ marginTop: 0 }}
      >
        {/* <div className="tab-container-title-mobile-3">Pre admission </div> */}

        {/* <span
          style={{
            fontSize: "12px",
            fontStyle: "italic",
          }}
        >
          {props.creatorName && props.dateOfCreation && (
            <div
              style={{
                fontSize: "12px",
                fontStyle: "italic",
                paddingLeft: "10px",
                paddingRight: "10px",
                marginTop: "10px",
              }}
            >
              {`Client added by ${props.creatorName} on ${props.dateOfCreation
                .toDate()
                .toLocaleString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}`}
            </div>
          )}

          <div
            style={{
              fontSize: "12px",
              fontStyle: "italic",
              paddingLeft: "10px",
              paddingRight: "10px",
              marginTop: "10px",
            }}
          >
            {docData.recordedAt
              ? `( Last modifications done by ${
                  docData.recordedBy
                } on ${docData.recordedAt.toDate().toLocaleString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })})`
              : "No modifications done "}
          </div>
        </span> */}

        <div className="tab-container-title">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: "10px",
            }}
          >
            {/* PRE ADMISSION{" "} */}
            <button
              type="button"
              className="pre-admission-activity-button"
              style={{
                marginLeft: "0px",
              }}
              onClick={() => openModalLogs(props.clientId)}
            >
              <span className="pre-admission-activity-icon">↻</span>
              Activity Logs
              <span className="pre-admission-activity-count">{logs.length}</span>
            </button>
          </div>
          <span className="pre-admission-activity-meta">
            {props.creatorName && props.dateOfCreation && (
              <div style={{ fontSize: "12px", fontStyle: "italic" }}>
                {`Client added by ${props.creatorName} on ${props.dateOfCreation
                  .toDate()
                  .toLocaleString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}`}
              </div>
            )}

            {/* {docData.recordedAt
              ? `( Last modifications done by ${
                  docData.recordedBy
                } on ${docData.recordedAt.toDate().toLocaleString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })})`
              : "No modifications done "} */}
          </span>
          {isDetailsModalOpen && (
            <StandardDrawer
              open={isDetailsModalOpen}
              onClose={() => setIsDetailsModalOpen(false)}
              SlideProps={{ direction: "left" }}
            >
              <div className="standard-drawer-form-wrapper">
                <StandardDrawerHeader
                  eyebrow="PRE-ADMISSION"
                  title="Activity log details"
                  subtitle="Change history"
                  onClose={closeDetailLogsModal}
                />
                {selectedLog &&
                  showLogDetails(selectedLog, closeDetailLogsModal)}
                <StandardDrawerFooter>
                  <Button variant="contained" onClick={closeDetailLogsModal}>
                    Close
                  </Button>
                </StandardDrawerFooter>
              </div>
            </StandardDrawer>
          )}
          {isModalLogsOpen && (
            <StandardDrawer
              open={isModalLogsOpen}
              onClose={() => setIsModalLogsOpen(false)}
              SlideProps={{ direction: "left" }}
            >
              <div className="standard-drawer-form-wrapper">
                <StandardDrawerHeader
                  eyebrow="PRE-ADMISSION"
                  title="Activity logs"
                  subtitle={`${logs.length} recorded changes`}
                  onClose={closeLogsModal}
                />
                <div className="pre-admission-activity-body">
                  {logs
                    .sort(
                      (a, b) => b.recordedAt.toDate() - a.recordedAt.toDate()
                    )
                    .map((log) => (
                      <LineLogsMobile
                        key={log.id}
                        log={log}
                        onDetailsClick={() => handleShowDetailsClick(log)}
                      />
                    ))}
                </div>
                <StandardDrawerFooter>
                  <Button variant="contained" onClick={closeLogsModal}>
                    Close
                  </Button>
                </StandardDrawerFooter>
              </div>
            </StandardDrawer>
          )}
        </div>
        <div className="tab-form-container">
          <UploaderAraEncapsulated
            {...props}
            fileField="filesUrlPreAdm"
            storageFolder="PreAdmission"
            uploadTitle="Upload associated documents"
            uploadDescription="Add up to 3 files. Uploads start automatically after selection."
          />
        </div>

        <div className="tab-form-container">
          <DropDownClientIdentifier
            title="Previous client identifier (if returning client)"
            value={previousClientIdentifier}
            onChange={handlePreviousClientIdentifier}
          />
        </div>
        <div className="tab-form-container">
          <DatePickerComponent
            title="Estimate Date of Arrival"
            width="150px"
            value={eta}
            onChange={handlEtaChange}
          />
          {requiresDurationOfStay && (
            <DropDownComponentMobile
              api="durationOfStay"
              title="Intended duration of stay"
              width="250px"
              value={durationOfStay}
              onChange={handleDurationOfStayChange}
              showValidation={true}
            />
          )}
        </div>

        <div className="tab-form-container">
          <DropDownComponentMobile
            api="yesno"
            title="Needs non-smoking room?"
            value={needsNonSmokingRoom}
            onChange={(val) => {
              setIsModified(true);
              setNeedsNonSmokingRoom(val);
            }}
            showValidation={false}
          />

          <InputComponentMobile
            title="Passport status"
            width="300"
            value={passportStatus}
            onChange={handlePassportStatusChange}
            showValidation={true}
          />

          <DropDownComponentMobile
            api="pendingReceived"
            title="Passport copy"
            value={passportCopy}
            onChange={handlePassportCopy}
            showValidation={true}
          />
        </div>

        <div className="tab-form-container">
          <DropDownComponentMobile
            api="pendingReceived"
            title="Flight details"
            value={flightDetails}
            onChange={handleFlightDetailsChange}
            showValidation={true}
          />

          <InputComponentMobile
            title="Itinerary"
            width="200"
            value={flightDetailsContent}
            onChange={handleFlightDetailsContent}
            showValidation={true}
          />
        </div>

        <div className="tab-form-container">
          <DropDownComponentMobile
            api="pendingBooked"
            title="VIP transfer"
            value={vipTransfer}
            onChange={handleVipTransferChange}
            showValidation={true}
          />
          <DropDownComponentMobile
            api="paymentDetail"
            title="Payment details"
            value={paymentDetails}
            onChange={handlePaymentDetailsChange}
            showValidation={true}
          />
        </div>

        <div className="tab-form-container">
          <DropDownComponentMobile
            api="nationalities"
            title="Nationality"
            value={nationality}
            onChange={handleNationalityChange}
            showValidation={true}
          />

          <DropDownComponentMobile
            api="maritalStatus"
            title="Marital status"
            value={maritalStatus}
            onChange={handleMaritalStatusChange}
            showValidation={true}
          />
          <InputComponentMobile
            title="If married not check, do you have a current partner?"
            width="250"
            value={currentPartner}
            onChange={handleCurrentPartnerChange}
          />
        </div>
        <div className="tab-form-container">
          <TextFieldComponentMobile
            title="Childrens or dependents"
            value={childrenOrDependents}
            onChange={handleChildrenOrDependentsChange}
            showValidation={true}
          />
        </div>
        <div className="tab-form-container">
          <TextFieldComponentMobile
            title="Current living arrangments"
            value={currentLivingArrangements}
            onChange={handleCurrentLivingArrangementsChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Dietary requierements"
            value={dietaryRequirements}
            onChange={handleDietaryRequirementsChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Funding Source"
            value={fundingSource}
            onChange={handleFundingSourceChange}
            showValidation={true}
          />
        </div>
      </div>

      <div className="container-main-plan-mobile-with-padding">
        <div className="tab-container-title-mobile-3 ">Addictions(s)</div>
        <div className="tab-form-container">
          <div className="column-div">
            <DropDownComponentMobile
              api="addictions"
              title="Primary Addiction (either substance or process above)"
              value={primaryAddiction}
              onChange={handlePrimaryAddictionChange}
              showValidation={true}
            />

            {primaryAddiction === "Other" ? (
              <InputComponentMobile
                title="If other selected, describe"
                width="300"
                value={addictionOther}
                onChange={handleAddictionOther}
              />
            ) : (
              ""
            )}
          </div>

          <div className="column-div">
            <DropDownComponentMobile
              api="addictions"
              title="Secondary Addiction (either substance or process above)"
              value={secondaryAddiction}
              onChange={handleSecondaryAddictionChange}
              showValidation={true}
            />

            {secondaryAddiction === "Other" ? (
              <InputComponentMobile
                title="If other selected, describe"
                width="300"
                value={secondaryAddictionOther}
                onChange={handleSecondaryAddictionOther}
              />
            ) : (
              ""
            )}
          </div>

          <TextFieldComponentMobile
            title="Substance Addiction(s), DoC Current Usage Levels (frequency, amount) and method (smoking, injection, snorting, orally)"
            value={substanceAddiction}
            onChange={handleSubstanceAddictionChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Any Current Withdrawal Symptoms"
            value={currentWithdrawalSymptoms}
            onChange={handleCurrentWithdrawalSymptomsChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Process Addiction(s)"
            placeholder="type, e.g., gambling, sex, porn, food, gaming; and frequency of engaging in process addiction behavior"
            value={processAddictions}
            onChange={handleProcessAddictionsChange}
            showValidation={true}
          />

          <TextFieldComponentMobile
            title="Addiction Treatment History"
            value={addictionTreatmentHistory}
            onChange={handleAddictionTreatmentHistoryChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Main Unwanted Consequences of Addiction"
            value={unwantedConsequencesOfAddiction}
            onChange={handleUnwantedConsequencesOfAddictionChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="How long has your using/drinking/process addiction been a problem and What Led You to Seek Treatment Now?"
            value={reasonForSeekingTreatment}
            onChange={handleReasonForSeekingTreatmentChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Treatment Goals"
            value={treatmentGoals}
            onChange={handleTreatmentGoalsChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Barriers for Rehab"
            value={barriersForRehab}
            onChange={handleBarriersForRehabChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Motivation for Treatment"
            value={motivationForTreatment}
            onChange={handleMotivationForTreatmentChange}
            showValidation={true}
          />
        </div>
      </div>

      <div className="container-main-plan-mobile-with-padding">
        <div className="tab-container-title-mobile-3 ">Mental health</div>
        <div className="tab-form-container">
          <div className="yes-no-container-mobile">
            {/* <div className="sentence-yes-no">
            
            </div> */}
            <FormControl
              style={{
                marginLeft: 5,
                border: !mentalHealthDiagnosis ? "1px solid red" : "none",
                padding: "10px",
                borderRadius: "5px",
              }}
              error={!mentalHealthDiagnosis}
            >
              <FormLabel
                id="demo-controlled-radio-buttons-group"
                style={{ color: "black" }}
              >
                Have you ever been formally diagnosed with a mental health issue
                by a mental health practioner?
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={mentalHealthDiagnosis}
                onChange={handleMentalHealthDiagnosisChange}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
              {!mentalHealthDiagnosis && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select an option
                </span>
              )}
            </FormControl>
          </div>

          <div
            className="yes-no-container-mobile"
            style={{ paddingLeft: "15px" }}
          >
            <div className="sentence-yes-no-mobile">If yes, which one :</div>
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "row",
                alignContent: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={anxiety}
                      onChange={handleAnxietyChange}
                    />
                  }
                  label="Anxiety"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={depression}
                      onChange={handleDepressionChange}
                    />
                  }
                  label="Depression"
                />
                <FormControlLabel
                  control={
                    <Checkbox checked={ptsd} onChange={handlePtsdChange} />
                  }
                  label="PTSD"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={personalityDisorder}
                      onChange={handlePersonalityDisorderChange}
                    />
                  }
                  label="Any Personality Disorder"
                />

                {personalityDisorder && (
                  <TextField
                    label="Specify"
                    value={specificDisorder}
                    onChange={handleSpecificDisorderChange}
                  />
                )}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={schizophrenia}
                      onChange={handleSchizophreniaChange}
                    />
                  }
                  label="Schizophrenia"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={schizoaffectiveDisorder}
                      onChange={handleSchizoaffectiveDisorderChange}
                    />
                  }
                  label="Schizoaffective disorder"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={bipolar}
                      onChange={handleBipolarChange}
                    />
                  }
                  label="Bipolar I or II"
                />

                <FormControlLabel
                  control={<Checkbox checked={adhd} onChange={handleAdhd} />}
                  label="ADHD/ADD"
                />
              </FormGroup>
            </div>
          </div>

          <div
            className="yes-no-container-mobile"
            style={{ marginLeft: "5px" }}
          >
            <FormControl>
              <FormLabel
                id="demo-controlled-radio-buttons-group"
                style={{ color: "black" }}
              >
                If bipolar: with psychotic features? :
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={bipolarWithPsychoticFeatures}
                onChange={handleBipolarWithPsychoticFeaturesChange}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </div>

          <div
            className="yes-no-container-mobile"
            style={{ marginLeft: "5px" }}
          >
            <FormControl
              style={{
                marginBottom: "20px",
                border: !hallucinations ? "1px solid red" : "none",
                padding: "10px",
              }}
            >
              <FormLabel
                id="demo-controlled-radio-buttons-group"
                style={{ color: "black" }}
              >
                Have you ever experienced any hallucinations (hearing things or
                seeing things that were not there)?
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={hallucinations}
                onChange={handleHallucinationsChange}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
              {!hallucinations && (
                <div style={{ color: "red", marginTop: "5px" }}>
                  Please select an option
                </div>
              )}
            </FormControl>
            <InputComponentMobile
              title="If yes, please explain"
              width="300"
              value={hallucinationsExplain}
              onChange={handleHallucinationsExplainChange}
            />
          </div>

          <div
            className="yes-no-container-mobile"
            style={{ marginLeft: "5px" }}
          >
            <FormControl
              style={{
                marginBottom: "20px",
                border: !delusionalThinking ? "1px solid red" : "none",
                padding: "10px",
              }}
            >
              <FormLabel
                id="demo-controlled-radio-buttons-group"
                style={{ color: "black" }}
              >
                Have you ever experienced delusional thinking (e.g., paranoia,
                persecution, others knowing your thoughts)?
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={delusionalThinking}
                onChange={handleDelusionalThinking}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
              {!delusionalThinking && (
                <div style={{ color: "red", marginTop: "5px" }}>
                  Please select an option
                </div>
              )}
            </FormControl>
            <InputComponentMobile
              title="If yes, please explain"
              width="300"
              value={delusionalThinkingExplain}
              onChange={handleDelusionalThinkingExplain}
            />
          </div>
        </div>
        <div className="tab-form-container" style={{ paddingLeft: "10px" }}>
          <TextFieldComponentMobile
            title="Are you currently experiencing mental health issues? "
            placeholder="e.g., depression, anxiety, mania"
            value={currentMentalHealthIssues}
            onChange={handleCurrentMentalHealthIssuesChange}
            showValidation={true}
          />
        </div>
        <div className="yes-no-container-mobile" style={{ marginLeft: "10px" }}>
          <FormControl
            style={{
              marginBottom: "20px",
              border: !suicidalThoughts ? "1px solid red" : "none",
              padding: "10px",
            }}
          >
            <FormLabel
              id="demo-controlled-radio-buttons-group"
              style={{ color: "black" }}
            >
              Have you had any suicidal thoughts in the past weeks or days or
              currently? :
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={suicidalThoughts}
              onChange={handleSuicidalThoughtsChange}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
            {!suicidalThoughts && (
              <div style={{ color: "red", marginTop: "5px" }}>
                Please select an option
              </div>
            )}
          </FormControl>
          <InputComponentMobile
            title="If so, when?"
            width="300"
            value={suicidalThoughtsWhen}
            onChange={handleSuicidalThoughtsWhenChange}
          />
          <InputComponentMobile
            title="If so, with intent?"
            width="300"
            value={suicidalThoughtsIntent}
            onChange={handleSuicidalThoughtsIntentChange}
          />
        </div>

        <div className="tab-form-container" style={{ paddingLeft: "15px" }}>
          <InputComponentMobile
            title="If current SI, have you made a plan on how you would kill yourself?"
            width="100%"
            value={suicidePlan}
            onChange={handleSuicidePlanChange}
          />

          <div
            className="yes-no-container-mobile"
            style={{ marginLeft: "5px" }}
          >
            <FormControl
              style={{
                marginBottom: "20px",
                border: !historyOfSuicideAttempts ? "1px solid red" : "none",
                padding: "10px",
              }}
            >
              <FormLabel
                id="demo-controlled-radio-buttons-group"
                style={{ color: "black" }}
              >
                History of Suicide Attempts :
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={historyOfSuicideAttempts}
                onChange={handleHistoryOfSuicideAttemptsChange}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
              {!historyOfSuicideAttempts && (
                <div style={{ color: "red", marginTop: "5px" }}>
                  Please select an option
                </div>
              )}
            </FormControl>
            <InputComponentMobile
              title="If so, when?"
              width="300"
              value={suicideAttemptsWhen}
              onChange={handleSuicideAttemptsWhenChange}
            />
          </div>

          <TextFieldComponentMobile
            title="Self-Harm (Current or Past) and Type"
            placeholder="e.g., cutting, burning, hair pulling"
            value={selfHarmType}
            onChange={handleSelfHarmTypeChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="If so, when was the last time you engaged in self-harm behavior?"
            value={lastSelfHarm}
            onChange={handleLastSelfHarmChange}
          />
          <TextFieldComponentMobile
            title="Trauma History"
            value={traumaHistory}
            onChange={handleTraumaHistoryChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Current or Past Trauma Treatment"
            value={traumaTreatment}
            onChange={handleTraumaTreatmentChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="History of Physical Violence Towards Others"
            value={historyPhysicalViolent}
            onChange={handleHistoryPhysicalViolence}
            showValidation={true}
          />

          <TextFieldComponentMobile
            title="Current or Past Mental Health Treatment"
            value={mentalHealthTreatment}
            onChange={handleMentalHealthTreatmentChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Current Provider (name and type of provider)"
            placeholder="e.g., psychiatrist, therapist"
            value={currentProvider}
            onChange={handleCurrentProviderChange}
            showValidation={true}
          />
        </div>
      </div>

      <div className="container-main-plan-mobile-with-padding">
        <div className="tab-container-title-mobile-3 ">Medical information</div>
        <div className="tab-form-container">
          <TextFieldComponentMobile
            title="History of Seizures"
            value={historyOfSeizures}
            onChange={handleHistoryOfSeizuresChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Current Medications"
            value={currentMedications}
            onChange={handleCurrentMedicationsChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Current/Past Injury and Any current related mobility issues?"
            value={currentPastInjury}
            onChange={handleCurrentPastInjuryChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Current Medical Illness(s)"
            placeholder="e.g., asthma, diabetes, STDs, HIV, Hep B or C"
            value={currentMedicalIllness}
            onChange={handleCurrentMedicalIllnessChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Allergies"
            value={allergies}
            onChange={handleAllergiesChange}
            showValidation={true}
          />
        </div>
      </div>

      <div className="container-main-plan-mobile-with-padding">
        <div className="tab-container-title-mobile-3 ">
          Potential eating disorder/issues
        </div>

        <div className="tab-form-container">
          <TextFieldComponentMobile
            title="Have you ever vomited or used laxatives to lose weight or purge food you have eaten?"
            value={eatingDisorderVomitingLaxatives}
            onChange={handleEatingDisorderVomitingLaxativesChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Do you consume a small amount of food (i.e., less than 1200 calories/day) on a regular basis to influence your shape or weight? "
            value={eatingDisorderFoodConsumption}
            onChange={handleEatingDisorderFoodConsumptionChange}
            showValidation={true}
          />
          <InputComponentMobile
            title="(if yes, ask for height and body weight"
            width="300"
            value={bodyHeight}
            onChange={handleBodyHeightChange}
          />
          <TextFieldComponentMobile
            title="Have you ever been diagnosed with an eating disorder?"
            value={eatingDisorderDiagnosis}
            onChange={handleEatingDisorderDiagnosisChange}
            showValidation={true}
          />
        </div>
      </div>

      <div className="container-main-plan-mobile-with-padding">
        <div className="tab-container-title-mobile-3 ">Legal</div>

        <div className="tab-form-container">
          <TextFieldComponentMobile
            title="Legal Problems (past or current)"
            value={legalProblems}
            onChange={handleLegalProblemsChange}
            showValidation={true}
          />
        </div>
      </div>
      <div className="container-main-plan-mobile-with-padding">
        <div className="tab-container-title-mobile-3 ">Wrap up</div>

        <div className="tab-form-container">
          <TextFieldComponentMobile
            title="How did you find out about Miracles Asia?"
            value={discoverMiraclesAsia}
            onChange={handleDiscoverMiraclesAsiaChange}
            showValidation={true}
          />
          <TextFieldComponentMobile
            title="Any preference regarding therapist?"
            placeholder="e.g., gender"
            value={therapistPreference}
            onChange={handleTherapistPreferenceChange}
            showValidation={true}
          />
        </div>
      </div>

      <div className="container-main-plan-mobile-with-padding">
        <div className="tab-container-title">
          Assessor: Read to the potential client or their representative when
          pre-admission assessment questions are completed:
        </div>

        <div className="tab-container-subtitle-mobile">
          Please understand that any information that you provided which is
          false or misleading (for example, you omitted important information in
          your response to any of the questions asked of you during this
          clinical assessment) can result in non-admission into Miracles Asia’s
          Program or an Administrative Discharge if admitted into Miracles
          Asia’s program. This clinical assessment is for your benefit, that is,
          to make sure Miracles Asia is the appropriate and best provider to
          meet your needs.
        </div>

        <div className="tab-container-subtitle">
          [Ask the potential client]: Do you understand what I just read you?
        </div>

        <div className="tab-container-subtitle">
          [If the person says, “yes,” Check the box]:
          <Checkbox
            checked={clientUnderstand}
            onChange={handleClientUnderstand}
          />
        </div>

        <div className="tab-container-subtitle">
          [If the person says, “no,” assist him/her to understand and then
          check the box above.]
        </div>
      </div>

      <div className="container-main-plan-red-mobile">
        <div className="tab-container-title-mobile-3 ">
          Assessor, complete the following based on the above pre-admission
          information (“red flag(s)” for admission)
        </div>
        <div className="tab-container-subtitle">Check any that apply:</div>
        <div className="yes-no-container">
          <Checkbox checked={bipolar12} onChange={handleBipolar12Change} />
          <div className="sentence-yes-no">Bipolar I or II</div>
        </div>
        <div className="yes-no-container">
          <Checkbox
            checked={previousPersonalityDisorder}
            onChange={handlePreviousPersonalityDisorderChange}
          />
          <div className="sentence-yes-no">
            previous personality disorder diagnosis: anti-social, narcissistic,
            or borderline
          </div>
        </div>
        <div className="yes-no-container">
          <Checkbox
            checked={activePsychosis}
            onChange={handleActivePsychosisChange}
          />
          <div className="sentence-yes-no">
            recent or current active psychosis
          </div>
        </div>
        <div className="yes-no-container">
          <Checkbox
            checked={diagnosisWithPsychoticFeatures}
            onChange={handleDiagnosisWithPsychoticFeaturesChange}
          />
          <div className="sentence-yes-no">
            mental health diagnosis with psychotic features
          </div>
        </div>
        <div className="yes-no-container">
          <Checkbox
            checked={recentSelfHarm}
            onChange={handleRecentSelfHarmChange}
          />
          <div className="sentence-yes-no">
            recent self-harm (within the past 3 months)
          </div>
        </div>
        <div className="yes-no-container">
          <Checkbox
            checked={violentBehavior}
            onChange={handleViolentBehaviorChange}
          />
          <div className="sentence-yes-no">violent crime or behavior</div>
        </div>
        <div className="yes-no-container">
          <Checkbox
            checked={historyOfSeizure}
            onChange={handleHistoryOfSeizureChange}
          />
          <div className="sentence-yes-no">history of seizure</div>
        </div>
        <div className="yes-no-container">
          <Checkbox
            checked={activeFoodRestriction}
            onChange={handleActiveFoodRestrictionChange}
          />
          <div className="sentence-yes-no">
            anorexia or bulimia or food restriction
          </div>
        </div>
        <div className="yes-no-container">
          <Checkbox
            checked={currentMobilityIssues}
            onChange={handleCurrentMobilityIssuesChange}
          />
          <div className="sentence-yes-no">current mobility issues</div>
        </div>
        <div className="yes-no-container">
          <Checkbox
            checked={currentComplexMedicalIssues}
            onChange={handleCurrentComplexMedicalIssuesChange}
          />
          <div className="sentence-yes-no">
            current complex medical issues (e.g., TBI, recent major surgeries)
          </div>
        </div>

        <div className="yes-no-container">
          <Checkbox
            checked={suicidalIdeation}
            onChange={handleSuicidalIdeationChange}
          />
          <div className="sentence-yes-no">
            suicidal ideation with intent or plan within the past month
          </div>
        </div>

        <div className="yes-no-container">
          <Checkbox
            checked={suicideAttempt}
            onChange={handleSuicideAttemptChange}
          />
          <div className="sentence-yes-no">
            suicide attempt within the past 3 months
          </div>
        </div>

        <div className="yes-no-container">
          <Checkbox checked={noneApply} onChange={handleNoneApplyChange} />
          <div className="sentence-yes-no">None apply</div>
        </div>
      </div>

      <div
        className="container-main-plan-mobile-with-padding"
        style={{ marginBottom: 30 }}
      >
        <div className="tab-container-title-mobile-3">Assessment outcome</div>

        <div className="tab-form-container">
          <DropDownComponentMobile
            api="status2"
            title="Status"
            value={assessmentStatus}
            onChange={handleAssessmentStatus}
            showValidation={true}
          />
        </div>

        <div>
          <TextFieldComponentMobile
            title="Reason"
            // placeholder="e.g., gender"
            value={assessmentReason}
            onChange={handleAssessmentReason}
            showValidation={true}
          />
        </div>
      </div>

      <div className="button-container-form-gi-mobile">
        <Button
          variant="contained"
          onClick={() => saveToFirestore(props.clientId)}
          style={
            isModified && !isLoading
              ? {
                  backgroundColor: "red",
                  color: "white",
                  marginLeft: "0px",
                }
              : {
                  backgroundColor: "#1565C0",
                  color: "white",
                  marginLeft: "0px",
                }
          }
          disabled={isLoading}
          //   onClick={handlePostRecord}

          sx={{
            height: "40px",
            width: "220px",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          {isLoading
            ? "SAVING MODIFICATIONS..."
            : isModified
            ? "CLICK TO SAVE"
            : "SAVE MODIFICATIONS"}
        </Button>
      </div>
    </div>
  );
}

export default PreAdmissionMobile;
